import useAppTheme from 'hooks/shared/useAppTheme';
import { Color } from 'presentation/theme/colorScheme';
import { CSSProperties, FC, PropsWithChildren } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';

interface Props extends PropsWithChildren {
  id: string;
  place?: PlacesType;
  clickable?: boolean;
  setIsOpen?: (value: boolean) => void;
  isOpen?: boolean;
  style?: CSSProperties;
  noArrow?: boolean;
}

const AppTooltip: FC<Props> = ({
  id,
  children,
  place,
  clickable,
  setIsOpen,
  isOpen,
  style,
  noArrow,
}) => {
  const theme = useAppTheme();

  return (
    <Tooltip
      id={id}
      clickable={clickable}
      place={place ?? 'bottom'}
      isOpen={isOpen}
      noArrow={noArrow}
      setIsOpen={setIsOpen}
      style={{
        backgroundColor: theme.colors[Color.Surface],
        boxShadow: '0px 0px 30px 0px #00000033',
        borderRadius: '6px',
        ...style,
      }}
      opacity={1}
    >
      {children}
    </Tooltip>
  );
};

export default AppTooltip;
